export const diamondParkingStyles = {
	primaryColor: '#00539b',
	header: {
		backgroundColor: '#c6ddf1',
		color: '#002a4e',
	},
	sidebar: {
		backgroundColor: '#c6ddf1',
		color: '#000814',
	},
	button: {
		backgroundColor: '#ed174c',
		color: '#ffffff',
		border: '1px solid #ed174c',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#0046AD',
			border: '1px solid #0046AD',
		},
	},
	title: {
		color: '#002a4e',
	},
	tab: {
		backgroundColor: '#c6ddf1',
		color: '#002a4e',
	},
	text: {
		color: '#404040',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#0046AD',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Diamond Parking Platform',
	},
	// Collapsed sidebar (~55px): compact icon. Expanded: full logo.
	logo: {
		small: {
			src: '/diamondParking/diamond-parking-icon.png',
			height: 36,
			width: 52,
		},
		large: {
			src: '/diamondParking/diamond-parking-logo.png',
			height: 70,
			width: 155,
		},
	},
	// Monthly checkout: icon only
	monthlyCheckoutLogo: {
		small: {
			src: '/diamondParking/diamond-parking-icon.png',
			height: 45,
			width: 90,
		},
		large: {
			src: '/diamondParking/diamond-parking-icon.png',
			height: 50,
			width: 100,
		},
	},
	favicon: {
		src: '/diamondParking/diamond-parking-logo.png',
	},
	socials: {},
	siteUrl: 'https://parkwithdiamond.com/',
	orgName: 'Diamond Parking',
};
